__turbopack_context__.v({
  "freeBox___3IypA": "PlasmicZpusob-module__LaZcEa__freeBox___3IypA",
  "freeBox__qdeg": "PlasmicZpusob-module__LaZcEa__freeBox__qdeg",
  "freeBox__x8PUr": "PlasmicZpusob-module__LaZcEa__freeBox__x8PUr",
  "h1": "PlasmicZpusob-module__LaZcEa__h1",
  "root": "PlasmicZpusob-module__LaZcEa__root",
  "slotTargetSlot": "PlasmicZpusob-module__LaZcEa__slotTargetSlot",
  "slotTargetSlot2": "PlasmicZpusob-module__LaZcEa__slotTargetSlot2",
  "svg___7KpC": "PlasmicZpusob-module__LaZcEa__svg___7KpC",
});
